import React, { useEffect, useState } from 'react'
import { IGenericBriefStepOption } from '../../types'
import { FormTextArea } from '@noissue-ui-kit/oldBranding/formTextArea'
import {
  usePreloadedAnswers,
  useReadOnlyMode,
} from '../BriefingFormDataProvider'
import { optionKeyToKebabCase } from '../../utils'

interface IBriefTextFieldOptions {
  options: IGenericBriefStepOption[]
  valueKey: string
  onChange: (value) => void
}

const sizeClassMapper = {
  s: 'min-h-[48px] h-[48px]',
  m: 'min-h-[128px] h-[128px]',
  l: 'min-h-[192px] h-[192px]',
}

export function BriefTextField({
  options,
  valueKey,
  onChange,
}: IBriefTextFieldOptions) {
  const [answers, setAnswers] = useState({})
  const preloadedAnswers = usePreloadedAnswers()
  const readOnlyMode = useReadOnlyMode()

  // Since this type for BriefStep can have sevaral "questions" with their own keys,
  // we submit and answer with [option.key] as its main identificator and use general (step's id) [valueKey]
  // as fallback if option key was forgotten to be entered
  const onAnswerSubmission = (key, value) => {
    const submittedAnswer = {}
    submittedAnswer[optionKeyToKebabCase(key || valueKey)] = value
    setAnswers({ ...answers, ...submittedAnswer })
  }

  useEffect(() => {
    onChange(answers)
  }, [answers])

  return (
    <div className="flex flex-wrap justify-between w-full">
      {options?.map((option) => (
        <FormTextArea
          key={`${option?.key}-textarea`}
          name={option?.key}
          className={`${sizeClassMapper[option?.textFieldSize ?? 's']}`}
          readOnly={readOnlyMode}
          initialValue={
            preloadedAnswers?.[option.key] || String(option?.value ?? '')
          }
          placeholder={option?.placeholder ?? ''}
          onChange={(value) => onAnswerSubmission(option.key, value)}
        />
      ))}
    </div>
  )
}
